export default "/images/empty-placeholder.svg?0fc237d288b70f1ed18081bd8f765197";